import { render, staticRenderFns } from "./pufaServiceAgreement.vue?vue&type=template&id=b9b68a94&scoped=true"
import script from "./pufaServiceAgreement.vue?vue&type=script&lang=js"
export * from "./pufaServiceAgreement.vue?vue&type=script&lang=js"
import style0 from "./pufaServiceAgreement.vue?vue&type=style&index=0&id=b9b68a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b68a94",
  null
  
)

export default component.exports